export const SmartInterestReason = {
  NOVA_NO_SLOTS_AVAILABLE: "Nova - no slots available",
  NO_SLOTS_AVAILABLE: "IMBP - No slots available",
  NO_SLOTS_WORKED: "IMBP - No slots work",
} as const
